import { AuthUser, User } from '../types';

export const getInitials = (name: string) => {
	if (!name?.trim()) return '';
	return name
		.match(/(^\S\S?|\s\S)?/g)
		?.map((v) => v.trim())
		?.join('')
		?.match(/(^\S|\S$)?/g)
		?.join('')
		.toLocaleUpperCase();
};

/**
 * Formats the users data to create the users full name
 *
 * @todo support the formatting of different languages based on the auth users locale
 *
 * @param user the user to format the name of
 * @returns the formatted full name of the user
 */
export const getName = (user: User) => {
	if (!user) return '';

	const value = [];
	if (user.givenName) value.push(user.givenName);
	if (user.familyName) value.push(user.familyName);
	return value.join(' ');
};

/**
 * Display name for either an org User or an AuthUser (e.g. for avatar initials).
 * AuthUsers do not have thumbnailUrl; use this with getInitials for fallback.
 */
export const getDisplayName = (user: User | AuthUser | null): string => {
	if (!user) return '';
	const value = [];
	if ('givenName' in user && user.givenName) value.push(user.givenName);
	if ('familyName' in user && user.familyName) value.push(user.familyName);
	const name = value.join(' ').trim();
	return name || ('email' in user ? (user.email ?? '') : '');
};
